import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminDashboardComponent } from '../dashboard'
import { VendorDashboardComponent } from './components/vendor-dashboard/vendor-dashboard.component';
export const routes: Routes = [
  { path: '', component: AdminDashboardComponent },
  { path: 'admin', component: AdminDashboardComponent },
  { path: 'vendor', component: VendorDashboardComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
